"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOTUsefulnessSurvey = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const frontend_infra_snack_1 = require("@forto-dev/frontend-infra-snack");
const notification_center_models_1 = require("@forto-dev/notification-center-models");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const upsertUserNotificationPreferences_1 = require("../../../features/NotificationsSettings/api/upsertUserNotificationPreferences");
const CheckboxSurveyQuestion_1 = require("../../../features/Survey/components/CheckboxSurveyQuestion");
const RadioSurveyQuestion_1 = require("../../../features/Survey/components/RadioSurveyQuestion");
const useSubmitSurveyStep_1 = require("../../../features/Survey/hooks/useSubmitSurveyStep");
const models_1 = require("../../../models");
const SurveyQuestionProps_1 = require("../types/SurveyQuestionProps");
const SurveyQuestionResponse_1 = require("../types/SurveyQuestionResponse");
const translations_1 = require("../types/translations");
const FreeTextSurveyQuestion_1 = require("./FreeTextSurveyQuestion");
const InlineButtonSurveyQuestion_1 = require("./InlineButtonSurveyQuestion");
const MOTUsefulnessSurvey = ({ reference, correlationType, correlationID, channelType, }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const snackService = (0, frontend_infra_snack_1.useSnackService)();
    const history = (0, react_router_dom_1.useHistory)();
    const submitSurveyStep = (0, useSubmitSurveyStep_1.useSubmitSurveyStep)();
    const selectedRuleID = reference;
    const upsert = (0, upsertUserNotificationPreferences_1.useUpsertUserNotificationPreferences)();
    const unsubscribeFrom = (ruleID, options) => {
        const preferences = [
            {
                reference: ruleID,
                web: false,
                instantEmail: false,
                digestEmail: false,
            },
        ];
        upsert.mutate({ preferences }, options);
    };
    const [openSurveyDialog, setOpenSurveyDialog] = (0, react_1.useState)(false);
    const [currentQuestion, setCurrentQuestion] = (0, react_1.useState)(undefined);
    const [currentResponse, setCurrentResponse] = (0, react_1.useState)(undefined);
    const [canProceed, setCanProceed] = (0, react_1.useState)(false);
    const q1 = {
        ...notification_center_models_1.motSurvey.questions[notification_center_models_1.SurveyQuestionID.MoTUsefulnessIsItUseful],
        component: InlineButtonSurveyQuestion_1.InlineButtonSurveyQuestion,
        onSubmit: (state) => {
            handleSubmitStep(state);
            if (state.responses.some((response) => response.id === notification_center_models_1.SurveyResponseID.MoTUsefulnessItIsUseful)) {
                setOpenSurveyDialog(true);
                setCurrentQuestion(q2);
            }
            if (state.responses.some((response) => response.id === notification_center_models_1.SurveyResponseID.MoTUsefulnessItIsNotUseful)) {
                setOpenSurveyDialog(true);
                setCurrentQuestion(q3);
            }
        },
    };
    const q2 = {
        id: notification_center_models_1.SurveyQuestionID.MoTUsefulnessIsItUseful,
        translationKey: translations_1.translations.takeAFewMoments,
        responses: [
            {
                id: notification_center_models_1.SurveyResponseID.MoTUsefulnessItIsUseful,
                translationKey: translations_1.translations.additionalInformation,
            },
        ],
        component: FreeTextSurveyQuestion_1.FreeTextSurveyQuestion,
        prefix: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "body2", mb: 3, children: translate(translations_1.translations.thankYou) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "subtitle2", mb: 2, children: translate(translations_1.translations.tellUsMore) })] })),
        submitLabel: translations_1.translations.done,
        onSubmit: (state) => {
            handleSubmitStep(state);
            setOpenSurveyDialog(false);
            snackService.showSuccess(translate(translations_1.translations.feedbackHasBeenSubmitted));
        },
    };
    const q3 = {
        ...notification_center_models_1.motSurvey.questions[notification_center_models_1.SurveyQuestionID.MoTUsefulnessWhyIsItNotUseful],
        component: CheckboxSurveyQuestion_1.CheckboxSurveyQuestion,
        prefix: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(silhouette_core_1.Typography, { variant: "body2", mb: 3, children: [translate(translations_1.translations.thankYou), " ", translate(translations_1.translations.weValueYourFeedback)] }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { variant: "subtitle2", mb: 2, children: translate(translations_1.translations.tellUsMore) })] })),
        submitLabel: translations_1.translations.next,
        onSubmit: (state) => {
            handleSubmitStep(state);
            if (correlationType === notification_center_models_1.CorrelationType.UserNotification &&
                state.responses.some((response) => response.id === notification_center_models_1.SurveyResponseID.MoTUsefulnessNotRelevant ||
                    response.id === notification_center_models_1.SurveyResponseID.MoTUsefulnessTooMany)) {
                setOpenSurveyDialog(true);
                setCurrentQuestion(q4);
            }
            else {
                setOpenSurveyDialog(false);
                snackService.showSuccess(translate(translations_1.translations.feedbackHasBeenSubmitted));
            }
        },
    };
    const q4 = {
        ...notification_center_models_1.motSurvey.questions[notification_center_models_1.SurveyQuestionID.MoTUsefulnessWhatWouldYouLikeToDo],
        responses: notification_center_models_1.motSurvey.questions[notification_center_models_1.SurveyQuestionID.MoTUsefulnessWhatWouldYouLikeToDo].responses.map((response) => ({
            ...response,
            render: (props) => {
                switch (props.id) {
                    case notification_center_models_1.SurveyResponseID.MoTUsefulnessUnsubscribe:
                        return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Box, { my: 1, children: [translate(props.translationKey, { title: translate(`${selectedRuleID}-title`) }), (0, jsx_runtime_1.jsx)("br", {}), `${translate(translations_1.translations.note)}: ${translate(translations_1.translations.youWillNotReceiveWarning)}`] }));
                    default:
                        return translate(props.translationKey);
                }
            },
        })),
        component: RadioSurveyQuestion_1.RadioSurveyQuestion,
        submitLabel: translations_1.translations.next,
        onSubmit: (state) => {
            handleSubmitStep(state);
            if (state.responses.some((response) => response.id === notification_center_models_1.SurveyResponseID.MoTUsefulnessUnsubscribe)) {
                unsubscribeFrom(selectedRuleID, {
                    onSuccess: () => {
                        setOpenSurveyDialog(false);
                        snackService.showSuccess(translate(translations_1.translations.unsubscribedSuccessfully, { title: translate(`${selectedRuleID}-title`) }));
                    },
                    onError: () => {
                        setCanProceed(true);
                    },
                });
            }
            else if (state.responses.some((response) => response.id === notification_center_models_1.SurveyResponseID.MoTUsefulnessConfigure)) {
                history.push(models_1.notificationSettingsRoute);
                setOpenSurveyDialog(false);
            }
            else {
                snackService.showSuccess(translate(translations_1.translations.feedbackHasBeenSubmitted));
                setOpenSurveyDialog(false);
            }
        },
    };
    const onAnswerInitialSurveyQuestion = (event) => {
        q1.onSubmit(event.surveyQuestionResponse);
    };
    const onDialogClosed = () => {
        setCurrentResponse(undefined);
        setCurrentQuestion(undefined);
        setCanProceed(false);
    };
    const handleCloseDialog = () => {
        setOpenSurveyDialog(false);
    };
    const handleSurveyQuestionResponseUpdate = (response) => {
        setCurrentResponse(response.surveyQuestionResponse);
        setCanProceed(response.status === SurveyQuestionProps_1.SurveyQuestionStatus.answered);
    };
    const handleSubmitStep = (submittedResponse) => {
        setCanProceed(false);
        submitSurveyStep.mutate({
            context: {
                channelType,
                correlationType,
                correlationID,
            },
            feedback: (0, SurveyQuestionResponse_1.toUserFeedbackRequest)(submittedResponse),
        });
    };
    const handleNext = () => {
        if (!currentQuestion || !currentResponse)
            return;
        currentQuestion.onSubmit(currentResponse);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(InlineButtonSurveyQuestion_1.InlineButtonSurveyQuestion, { question: q1, onChange: onAnswerInitialSurveyQuestion }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.Dialog, { maxWidth: "sm", open: openSurveyDialog, TransitionProps: { onExited: onDialogClosed }, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.DialogTitle, { showClose: true, onClose: handleCloseDialog, children: translate(translations_1.translations.surveyName) }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.DialogContent, { children: [currentQuestion != null ? currentQuestion.prefix : undefined, currentQuestion && ((0, jsx_runtime_1.jsx)(currentQuestion.component, { question: currentQuestion, onChange: handleSurveyQuestionResponseUpdate }))] }), (0, jsx_runtime_1.jsxs)(silhouette_core_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { onClick: handleCloseDialog, children: translate(translations_1.translations.cancel) }), (0, jsx_runtime_1.jsx)(silhouette_core_1.Button, { onClick: handleNext, variant: "contained", disabled: !canProceed, "data-testid": "survey-submit-button", children: translate(currentQuestion?.submitLabel != null ? currentQuestion.submitLabel : translations_1.translations.next) })] })] })] }));
};
exports.MOTUsefulnessSurvey = MOTUsefulnessSurvey;
//# sourceMappingURL=MOTUsefulnessSurvey.js.map